import { render, staticRenderFns } from "./desertRuin.vue?vue&type=template&id=0752c6ba&"
import script from "./desertRuin.vue?vue&type=script&lang=js&"
export * from "./desertRuin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports